module.exports = __webpack_public_path__ + "img/bench-arrangement.2ef47fa5.jpg";